import React, {useCallback, useEffect, useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {BreadcrumbsItem} from "./BreadcrumbsItem";
import {IBreadcrumb} from "./IBreadcrumb";
import {SchemaBreadcrumbs} from "./SchemaBreadcrumbs";
import {SeparatorIcon} from "./SeparatorIcon";

export interface IBreadCrumbsProps {
    items: IBreadcrumb[];
    className?: string;
    homePageUrl: string;
    homePageIcon?: React.JSX.Element;
}

const HOME_PAGE_LABEL = "Strona główna";

export const Breadcrumbs = (props: IBreadCrumbsProps) => {
    const {homePageUrl, items, className, homePageIcon} = props;

    const listRef = useRef<HTMLOListElement | null>(null);
    const [isOverlayVisible, setOverlay] = useState<boolean>(false);

    const resizeHandler = useCallback(() => {
        listRef.current && (listRef.current.scrollLeft += 50);
        listRef.current && listRef.current.scrollLeft > 0 ? setOverlay(true) : setOverlay(false);
    }, []);

    useEffect(() => {
        listRef.current && (listRef.current.scrollLeft += 2000);
        listRef.current && listRef.current.scrollLeft > 0 ? setOverlay(true) : setOverlay(false);

        window.addEventListener("resize", resizeHandler);

        return () => {
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);

    return (
        <>
            <nav className={cx(breadcrumbsNav, className)} id="breadcrumbs">
                <ol className={breadcrumbsList} id="breadcrumbs-list" ref={listRef}>
                    <li>
                        <a href={homePageUrl}>
                            <span className={hideText}>{HOME_PAGE_LABEL}</span>

                            {homePageIcon ? homePageIcon : defaultHomePageIcon}
                        </a>

                        <SeparatorIcon />
                    </li>

                    {items.map((item, index) => (
                        <BreadcrumbsItem {...item} key={item.key ?? item.name} isLinkingToCurrentLocation={index === items.length - 1} />
                    ))}
                </ol>

                {isOverlayVisible && <span className={bgOverlay} id="breadcrumbs-overlay" />}
            </nav>
            <SchemaBreadcrumbs items={[{name: HOME_PAGE_LABEL, url: homePageUrl}, ...items]} />
        </>
    );
};

const defaultHomePageIcon = (
    <svg width={12} height={12} viewBox="0 0 10 10">
        <path d="M9.83,4.91,5.81.53a1.18,1.18,0,0,0-1.62,0l-4,4.38a.66.66,0,0,0,0,.92A.68.68,0,0,0,.68,6a.66.66,0,0,0,.45-.21l.15-.16L1.55,8.8a1.09,1.09,0,0,0,1.09,1H7.36a1.1,1.1,0,0,0,1.09-1l.27-3.17.15.16a.68.68,0,0,0,.92,0A.66.66,0,0,0,9.83,4.91ZM7.66,4.29l-.37,4.4H2.71l-.37-4.4L5,1.39Z" />
    </svg>
);

const breadcrumbsList = css({
    margin: 0,
    padding: "1rem 0",
    listStyle: "none",
    fontSize: "1.244rem",
    fontWeight: 500,
    lineHeight: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    overflowX: "auto",
    overflowY: "hidden",
    position: "relative",
    whiteSpace: "nowrap",
    width: "100%",
    zIndex: 0,

    "& > li": {
        color: "var(--colors-gray-700)",
        fill: "var(--colors-gray-700)",
        display: "inline-block",
        whiteSpace: "nowrap",

        "& > a": {
            color: "inherit",
            fill: "var(--colors-gray-700)"
        },

        "&:last-of-type": {
            color: "var(--colors-gray-800)",
            fill: "var(--colors-gray-800)",

            "& > a": {
                color: "inherit",
                fill: "var(--colors-secondary)"
            },

            "& > i": {
                visibility: "hidden"
            }
        }
    }
});

const breadcrumbsNav = css({
    position: "relative"
});

const hideText = css({
    fontSize: "0px",
    lineHeight: "0px",
    color: "transparent",
    textShadow: "none",
    backgroundColor: "transparent",
    border: 0
});

const bgOverlay = css({
    backgroundImage: "linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 100%)",
    backgroundRepeat: "repeat-x",
    left: 0,
    position: "absolute",
    top: 0,
    width: "4rem",
    bottom: 0,
    display: "block"
});
import React, {useCallback, useEffect, useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {BreadcrumbsItem} from "./BreadcrumbsItem";
import {IBreadcrumb} from "./IBreadcrumb";
import {SchemaBreadcrumbs} from "./SchemaBreadcrumbs";
import {SeparatorIcon} from "./SeparatorIcon";

export interface IBreadCrumbsProps {
    items: IBreadcrumb[];
    className?: string;
    homePageUrl: string;
    homePageIcon?: React.JSX.Element;
}

const HOME_PAGE_LABEL = "Strona główna";

export const Breadcrumbs = (props: IBreadCrumbsProps) => {
    const {homePageUrl, items, className, homePageIcon} = props;

    const listRef = useRef<HTMLOListElement | null>(null);
    const [isOverlayVisible, setOverlay] = useState<boolean>(false);

    const resizeHandler = useCallback(() => {
        listRef.current && (listRef.current.scrollLeft += 50);
        listRef.current && listRef.current.scrollLeft > 0 ? setOverlay(true) : setOverlay(false);
    }, []);

    useEffect(() => {
        listRef.current && (listRef.current.scrollLeft += 2000);
        listRef.current && listRef.current.scrollLeft > 0 ? setOverlay(true) : setOverlay(false);

        window.addEventListener("resize", resizeHandler);

        return () => {
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);

    return (
        <>
            <nav className={cx(breadcrumbsNav, className)} id="breadcrumbs">
                <ol className={breadcrumbsList} id="breadcrumbs-list" ref={listRef}>
                    <li>
                        <a href={homePageUrl}>
                            <span className={hideText}>{HOME_PAGE_LABEL}</span>

                            {homePageIcon ? homePageIcon : defaultHomePageIcon}
                        </a>

                        <SeparatorIcon />
                    </li>

                    {items.map((item, index) => (
                        <BreadcrumbsItem {...item} key={item.key ?? item.name} isLinkingToCurrentLocation={index === items.length - 1} />
                    ))}
                </ol>

                {isOverlayVisible && <span className={bgOverlay} id="breadcrumbs-overlay" />}
            </nav>
            <SchemaBreadcrumbs items={[{name: HOME_PAGE_LABEL, url: homePageUrl}, ...items]} />
        </>
    );
};

const defaultHomePageIcon = (
    <svg width={12} height={12} viewBox="0 0 10 10">
        <path d="M9.83,4.91,5.81.53a1.18,1.18,0,0,0-1.62,0l-4,4.38a.66.66,0,0,0,0,.92A.68.68,0,0,0,.68,6a.66.66,0,0,0,.45-.21l.15-.16L1.55,8.8a1.09,1.09,0,0,0,1.09,1H7.36a1.1,1.1,0,0,0,1.09-1l.27-3.17.15.16a.68.68,0,0,0,.92,0A.66.66,0,0,0,9.83,4.91ZM7.66,4.29l-.37,4.4H2.71l-.37-4.4L5,1.39Z" />
    </svg>
);

const breadcrumbsList = css({
    margin: 0,
    padding: "1rem 0",
    listStyle: "none",
    fontSize: "1.244rem",
    fontWeight: 500,
    lineHeight: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    overflowX: "auto",
    overflowY: "hidden",
    position: "relative",
    whiteSpace: "nowrap",
    width: "100%",
    zIndex: 0,

    "& > li": {
        color: "var(--colors-gray-700)",
        fill: "var(--colors-gray-700)",
        display: "inline-block",
        whiteSpace: "nowrap",

        "& > a": {
            color: "inherit",
            fill: "var(--colors-gray-700)"
        },

        "&:last-of-type": {
            color: "var(--colors-gray-800)",
            fill: "var(--colors-gray-800)",

            "& > a": {
                color: "inherit",
                fill: "var(--colors-secondary)"
            },

            "& > i": {
                visibility: "hidden"
            }
        }
    }
});

const breadcrumbsNav = css({
    position: "relative"
});

const hideText = css({
    fontSize: "0px",
    lineHeight: "0px",
    color: "transparent",
    textShadow: "none",
    backgroundColor: "transparent",
    border: 0
});

const bgOverlay = css({
    backgroundImage: "linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 100%)",
    backgroundRepeat: "repeat-x",
    left: 0,
    position: "absolute",
    top: 0,
    width: "4rem",
    bottom: 0,
    display: "block"
});
